import { useInvoicePayOrders, usePurchasePayOrders } from 'hooks/payorders.hook';
import { useMemo } from 'react';

export const useRelatedPayOrders = (invoiceId: number) => {
  const payOrders = useInvoicePayOrders(invoiceId);
  
  const payOrdersTotal = useMemo(
    () => payOrders.items.reduce((prev, curr) => (
      prev + curr.rows.reduce((acc, row) => acc + row.amount, 0)),
    0),
    [payOrders]);

  return ({
    payOrders,
    payOrdersTotal
  });
};

export const useRelatedPurchasePayOrders = (invoiceId: number, purchaseId: number) => {
  const payOrders = usePurchasePayOrders(invoiceId, purchaseId);
  
  const payOrdersTotal = useMemo(
    () => payOrders.items.reduce((prev, curr) => (
      prev + curr.rows.reduce((acc, row) => acc + row.amount, 0)),
    0),
    [payOrders]);

  return ({
    payOrders,
    payOrdersTotal
  });
};
